import React, { useState, useRef, useEffect } from 'react';
import logo from '../../assets/logo.jpg';
import { useApp } from '../../context/AppContext';
import { allTarifs, getTaux } from '../../data/tarifsData';
import './Chatbot.css';

// ──────────────────────────────────────────────────────────
// BASE DE CONNAISSANCE — explications pédagogiques détaillées
// pour les concepts génériques (ce qu'est un site vitrine, etc.)
// Ceci reste statique volontairement : ce sont des définitions,
// pas des données catalogue qui changent depuis l'Admin.
// ──────────────────────────────────────────────────────────
const KNOWLEDGE = {
  'site vitrine': {
    title: '🌐 Site Vitrine',
    html: `<strong>Un site vitrine</strong>, c'est votre carte de visite sur internet.<br><br>
Il présente votre entreprise, vos services, vos coordonnées et permet aux visiteurs de vous contacter.<br><br>
<strong>Idéal pour :</strong><br>
&nbsp;• PME, artisans, professions libérales<br>
&nbsp;• Associations, ONG, institutions<br>
&nbsp;• Tout projet voulant une présence professionnelle en ligne<br><br>
<strong>Ce qu'il contient :</strong><br>
&nbsp;• Page d'accueil attractive et moderne<br>
&nbsp;• Présentation de vos services<br>
&nbsp;• Formulaire de contact<br>
&nbsp;• 100% responsive (mobile, tablette, PC)`,
    sugs: ['🛒 Site e-commerce', '📱 Application web', '💰 Tous les tarifs', '📞 Demander un devis'],
  },
  'site e-commerce': {
    title: '🛒 Site E-commerce',
    html: `<strong>Un site e-commerce</strong> vous permet de vendre vos produits ou services directement en ligne, 24h/24.<br><br>
<strong>Fonctionnalités incluses :</strong><br>
&nbsp;• Catalogue de produits avec photos et prix<br>
&nbsp;• Panier d'achat et commandes en ligne<br>
&nbsp;• Paiement sécurisé (Mobile Money, carte…)<br>
&nbsp;• Gestion des stocks et livraisons<br>
&nbsp;• Tableau de bord vendeur<br><br>
<strong>Idéal pour :</strong> boutiques, grossistes, artisans qui veulent vendre sans frontières.`,
    sugs: ['🌐 Site vitrine', '📱 Application web', '💰 Tous les tarifs', '📞 Demander un devis'],
  },
  'application web': {
    title: '📱 Application Web (Flask / React)',
    html: `<strong>Une application web</strong> est un logiciel accessible depuis votre navigateur — bien plus puissant qu'un simple site.<br><br>
<strong>Exemples concrets :</strong><br>
&nbsp;• Système de gestion d'une clinique ou d'une école<br>
&nbsp;• Plateforme de commande et suivi de livraison<br>
&nbsp;• Application de suivi de stock ou de personnel<br>
&nbsp;• Tableau de bord analytique en temps réel<br>
&nbsp;• Intranet d'entreprise<br><br>
<strong>Technologies utilisées :</strong><br>
&nbsp;• Frontend : <strong>React.js</strong> (interface moderne)<br>
&nbsp;• Backend : <strong>Flask (Python)</strong> ou Node.js<br>
&nbsp;• Base de données : PostgreSQL, MySQL, SQLite`,
    sugs: ['💻 Système de gestion', '🔌 API REST', '💰 Tous les tarifs', '📞 Demander un devis'],
  },
  'système de gestion': {
    title: '🗂️ Système de Gestion Sur Mesure',
    html: `<strong>Un système de gestion</strong> est une application complète qui automatise et centralise les opérations de votre organisation.<br><br>
<strong>Exemples réalisés par KOTOSTECHNOLOGY :</strong><br>
&nbsp;• Système de gestion d'église (pasteurs, membres, finances)<br>
&nbsp;• Logiciel de stock et de ventes<br>
&nbsp;• Gestion d'hôpital ou de pharmacie<br>
&nbsp;• ERP pour PME (achats, RH, comptabilité)<br><br>
<strong>Avantages :</strong><br>
&nbsp;• 100% adapté à vos besoins spécifiques<br>
&nbsp;• Multi-utilisateurs avec rôles et permissions<br>
&nbsp;• Rapports et statistiques automatiques<br>
&nbsp;• Accessible en ligne ou en réseau local<br><br>
💡 Regardez aussi <strong>KotosShop</strong> — plusieurs systèmes de gestion prêts à l'emploi existent déjà (pharmacie, hôpital, finance, RH...), moins chers qu'un développement sur mesure.`,
    sugs: ['🛍️ Boutique KotosShop', '📱 Application web', '📞 Demander un devis'],
  },
  'api': {
    title: '🔌 API REST / Backend',
    html: `<strong>Une API REST</strong> est un pont de communication entre différentes applications ou systèmes.<br><br>
<strong>À quoi ça sert ?</strong><br>
&nbsp;• Connecter votre app mobile avec votre serveur<br>
&nbsp;• Intégrer un paiement Mobile Money sur votre site<br>
&nbsp;• Permettre à des partenaires d'accéder à vos données<br>
&nbsp;• Alimenter un tableau de bord en temps réel<br><br>
<strong>Technologies :</strong> Flask (Python), Node.js, FastAPI`,
    sugs: ['📱 Application web', '🗂️ Système de gestion', '📞 Demander un devis'],
  },
  'dashboard': {
    title: '📊 Dashboard / Tableau de Bord',
    html: `<strong>Un dashboard interactif</strong> transforme vos données brutes en graphiques et indicateurs clés compréhensibles en un coup d'œil.<br><br>
<strong>Ce que vous pouvez visualiser :</strong><br>
&nbsp;• Chiffre d'affaires, ventes, performances<br>
&nbsp;• Suivi en temps réel de votre activité<br>
&nbsp;• Comparaisons et tendances<br>
&nbsp;• Alertes automatiques sur seuils<br><br>
<strong>Outils :</strong> React + Chart.js, Power BI, Plotly, Metabase`,
    sugs: ['📊 Data Science', '📱 Application web', '📞 Demander un devis'],
  },
  'application mobile': {
    title: '📲 Application Mobile',
    html: `<strong>Une application mobile</strong> est installée sur smartphone (Android / iOS) et peut fonctionner même sans connexion.<br><br>
<strong>Types d'applications :</strong><br>
&nbsp;• Commerce : livraison, e-commerce, réservation<br>
&nbsp;• Services : santé, éducation, transport<br>
&nbsp;• Interne : outil de terrain pour vos employés<br>
&nbsp;• Communautaire : réseau social, forum<br><br>
<strong>Technologies :</strong> React Native, Flutter`,
    sugs: ['📱 Application web', '🗂️ Système de gestion', '📞 Demander un devis'],
  },
  'data science': {
    title: '📊 Data Science & Intelligence Artificielle',
    html: `<strong>La Data Science</strong> consiste à extraire de la valeur de vos données pour prendre de meilleures décisions.<br><br>
<strong>Ce qu'on peut faire pour vous :</strong><br>
&nbsp;• Analyser vos ventes, clients, comportements<br>
&nbsp;• Prédire la demande future (forecasting)<br>
&nbsp;• Détecter des anomalies ou fraudes<br>
&nbsp;• Créer des modèles d'IA sur mesure<br>
&nbsp;• Automatiser vos rapports mensuels<br><br>
<strong>Outils :</strong> Python, Pandas, Scikit-learn, TensorFlow, Power BI, Tableau`,
    sugs: ['🤖 Machine Learning', '📊 Dashboard BI', '💰 Tarifs Data Science', '📞 Demander un devis'],
  },
  'machine learning': {
    title: '🤖 Machine Learning & IA',
    html: `<strong>Le Machine Learning</strong> permet à une machine d'apprendre automatiquement à partir de données.<br><br>
<strong>Applications concrètes :</strong><br>
&nbsp;• Prédire quels clients vont partir (churn prediction)<br>
&nbsp;• Estimer le prix d'un bien immobilier<br>
&nbsp;• Classer automatiquement des documents<br>
&nbsp;• Recommander des produits à un client<br>
&nbsp;• Détecter des fraudes en temps réel`,
    sugs: ['📊 Data Science', '📊 Dashboard BI', '📞 Demander un devis'],
  },
  'solaire': {
    title: '☀️ Installation Solaire Photovoltaïque',
    html: `<strong>L'énergie solaire photovoltaïque</strong> convertit la lumière du soleil en électricité grâce à des panneaux solaires.<br><br>
<strong>Ce que nous proposons :</strong><br>
&nbsp;• Dimensionnement gratuit selon vos besoins<br>
&nbsp;• Installation de panneaux, batteries, onduleurs<br>
&nbsp;• Systèmes autonomes (off-grid) ou raccordés<br>
&nbsp;• Maintenance préventive annuelle<br><br>
☀️ Économisez jusqu'à <strong>80%</strong> sur votre facture d'électricité !`,
    sugs: ['🔩 Forage eau', '💰 Tarifs solaires', '📞 Devis gratuit'],
  },
  'forage': {
    title: '🔩 Forage & Installation Eau',
    html: `<strong>Le forage</strong> consiste à creuser un puits profond pour atteindre les nappes phréatiques et accéder à l'eau potable.<br><br>
<strong>Nos prestations :</strong><br>
&nbsp;• Études géologiques et identification de nappes<br>
&nbsp;• Forage de puits (profondeur selon terrain)<br>
&nbsp;• Installation de pompes immergées<br>
&nbsp;• Construction de châteaux d'eau<br>
&nbsp;• Installation de suppresseurs<br>
&nbsp;• Maintenance et réparation réseau<br><br>
📋 Devis gratuit après visite technique sur site.`,
    sugs: ['☀️ Solaire', '📞 Devis gratuit'],
  },
  'graphisme': {
    title: '🖨️ Photocopie, Saisie & Graphisme',
    html: `<strong>Notre atelier de graphisme</strong> crée vos supports de communication visuels et professionnels.<br><br>
<strong>Nos prestations :</strong><br>
&nbsp;• 🖨️ Photocopie & impression<br>
&nbsp;• ✏️ Saisie et mise en page de documents<br>
&nbsp;• 🏢 Création de logos<br>
&nbsp;• 🖼️ Bannières et affiches<br>
&nbsp;• 📄 Cartes de visite, flyers, brochures<br>
&nbsp;• 🖥️ Impression grand format (bâches, panneaux)`,
    sugs: ['🌐 Site vitrine', '📞 Contact', '💰 Tous les tarifs'],
  },
};

// ──────────────────────────────────────────────────────────
// MOBILE MONEY OPERATORS
// ──────────────────────────────────────────────────────────
const OPERATORS = [
  {
    name: 'MTN Mobile Money', emoji: '🟡', color: '#FFB800', short: 'MTN MoMo',
    ussd: '*880#', prefixes: ['96', '97', '67', '62'], comment: 'Réseau le plus utilisé au Bénin',
    steps: [
      'Composez <strong>*880#</strong> sur votre téléphone MTN',
      'Choisissez <em>"Envoyer de l\'argent"</em>',
      'Entrez le numéro MTN de KOTOSTECHNOLOGY',
      'Saisissez le montant exact en FCFA',
      'Confirmez avec votre code secret MTN MoMo',
      'Envoyez le SMS de confirmation à votre chargé de compte',
    ],
  },
  {
    name: 'Moov Money', emoji: '🔵', color: '#0066CC', short: 'Moov Money',
    ussd: '*555#', prefixes: ['90', '91', '93', '94', '95', '61', '64', '65'], comment: 'Deuxième opérateur national',
    steps: [
      'Composez <strong>*555#</strong> sur votre téléphone Moov',
      'Choisissez <em>"Transfert d\'argent"</em>',
      'Entrez le numéro Moov de KOTOSTECHNOLOGY',
      'Saisissez le montant',
      'Confirmez avec votre code PIN Moov Money',
      'Envoyez le SMS de confirmation à votre chargé de compte',
    ],
  },
  {
    name: 'Celtis Cash', emoji: '🟢', color: '#00AA44', short: 'Celtis Cash',
    ussd: '*144#', prefixes: ['98', '99', '66'], comment: 'Opérateur Celtis — en expansion au Bénin',
    steps: [
      'Composez <strong>*144#</strong> sur votre téléphone Celtis',
      'Sélectionnez <em>"Envoyer de l\'argent"</em>',
      'Entrez le numéro Celtis de KOTOSTECHNOLOGY',
      'Saisissez le montant',
      'Confirmez avec votre code secret',
      'Envoyez le SMS de confirmation à votre chargé de compte',
    ],
  },
];

// ──────────────────────────────────────────────────────────
// INDEX DYNAMIQUE DU CATALOGUE
// Reconstruit à CHAQUE message à partir de `data` (état live de
// l'app / Firebase). Ajouter un produit, un pack, une formation
// depuis l'Admin rend AUTOMATIQUEMENT le bot capable d'en parler,
// sans toucher au code du chatbot.
// ──────────────────────────────────────────────────────────
function buildCatalogIndex(data) {
  const idx = [];

  // KotosShop — applications prêtes à l'emploi
  (data.produits || []).forEach(p => {
    idx.push({
      type: 'produit', name: p.name, desc: p.desc,
      fcfa: p.priceFcfa, fcfaMax: p.priceFcfaMax, unit: p.unit,
      onDevis: p.onDevis,
      keywords: `${p.name} ${p.desc}`.toLowerCase(),
    });
  });

  // Pipeline — applications en développement
  (data.pipeline || []).forEach(p => {
    idx.push({
      type: 'pipeline', name: p.name, desc: p.desc, statut: p.statut,
      keywords: `${p.name} ${p.desc}`.toLowerCase(),
    });
  });

  // Formations
  (data.formations || []).forEach(f => {
    idx.push({
      type: 'formation', name: f.title, desc: (f.modules || []).join(', '),
      fcfa: f.fcfa, duree: f.duree, places: f.places, mode: f.mode,
      keywords: `${f.title} ${(f.modules || []).join(' ')}`.toLowerCase(),
    });
  });

  // Domaines de services généraux
  (data.domaines || []).forEach(d => {
    idx.push({
      type: 'domaine', name: d.name, desc: d.desc,
      fcfa: d.priceFcfa, priceLabel: d.priceLabel, priceText: d.price,
      keywords: `${d.name} ${d.desc} ${(d.services || []).join(' ')}`.toLowerCase(),
    });
  });

  // Packs de digitalisation par secteur
  (data.digitalisation?.secteurs || []).forEach(s => {
    (s.packs || []).forEach(pack => {
      idx.push({
        type: 'digitalisation', name: `${s.name} — Pack ${pack.name}`, desc: pack.desc,
        fcfa: pack.prixFcfa, unit: 'installation',
        keywords: `${s.name} ${pack.name} ${pack.desc} digitalisation digitaliser`.toLowerCase(),
      });
    });
  });

  return idx;
}

// Recherche simple par mots-clés — retourne le meilleur candidat
// ou null si rien ne dépasse un score minimal.
function searchCatalog(index, query) {
  const q = query.toLowerCase();
  const words = q.split(/\s+/).filter(w => w.length > 2);
  if (words.length === 0) return null;

  let best = null, bestScore = 0;
  index.forEach(item => {
    let score = 0;
    words.forEach(w => { if (item.keywords.includes(w)) score += 1; });
    if (item.name.toLowerCase().includes(q)) score += 3;
    if (score > bestScore) { bestScore = score; best = item; }
  });
  return bestScore > 0 ? best : null;
}

function fmtCatalogPrice(item, T) {
  if (item.type === 'pipeline') return null;
  if (item.fcfa == null) return item.priceText ? `${item.priceLabel || ''} ${item.priceText}`.trim() : 'Sur devis';
  const fcfaStr = item.fcfa.toLocaleString('fr-FR');
  const usdStr  = Math.round(item.fcfa / T.USD).toLocaleString('fr-FR');
  const eurStr  = Math.round(item.fcfa / T.EUR).toLocaleString('fr-FR');
  let range = '';
  if (item.fcfaMax && item.fcfaMax !== item.fcfa) {
    range = ` – ${item.fcfaMax.toLocaleString('fr-FR')}`;
  }
  return `${fcfaStr}${range} FCFA (≈ ${usdStr} $ / ${eurStr} €)${item.unit ? ' / ' + item.unit : ''}`;
}

function formatCatalogAnswer(item, T) {
  let html = `<strong>${item.name}</strong><br>${item.desc || ''}<br><br>`;
  if (item.type === 'pipeline') {
    html += `🚧 <strong>Statut :</strong> ${item.statut} — bientôt disponible !`;
  } else {
    const price = fmtCatalogPrice(item, T);
    html += item.onDevis
      ? `💰 <strong>Tarif :</strong> Sur devis — contactez-nous pour une estimation gratuite.`
      : `💰 <strong>Tarif :</strong> ${price}`;
    if (item.type === 'formation') {
      html += `<br>⏱️ ${item.duree} · 👥 ${item.places} · 📍 ${item.mode}`;
    }
  }
  return html;
}

// ──────────────────────────────────────────────────────────
// COMPOSANT
// ──────────────────────────────────────────────────────────
export default function Chatbot() {
  const { data } = useApp();
  const [open,   setOpen]   = useState(false);
  const [msgs,   setMsgs]   = useState([]);
  const [sugs,   setSugs]   = useState([]);
  const [input,  setInput]  = useState('');
  const [badge,  setBadge]  = useState(true);
  const msgsRef = useRef(null);

  useEffect(() => {
    if (open && msgs.length === 0) initChat();
    // eslint-disable-next-line
  }, [open]);

  useEffect(() => {
    if (msgsRef.current) msgsRef.current.scrollTop = msgsRef.current.scrollHeight;
  }, [msgs]);

  const addBot  = html => setMsgs(m => [...m, { type:'bot',  html }]);
  const addUser = txt  => setMsgs(m => [...m, { type:'user', html: txt }]);

  function initChat() {
    addBot(
      `👋 Bienvenue chez <strong>KOTOSTECHNOLOGY</strong> !<br>` +
      `Je suis <strong>KotoBot</strong>, votre assistant virtuel.<br><br>` +
      `Je connais <strong>tous nos services, produits et tarifs à jour</strong> — demandez-moi n'importe quoi : un service, une application KotosShop, une formation, un pack de digitalisation...<br><br>` +
      `Que souhaitez-vous savoir ?`
    );
    setSugs(['🌐 Site vitrine','🛍️ Boutique KotosShop','🚀 Digitalisation','🎓 Formations','☀️ Solaire','💳 Comment payer ?']);
  }

  function respond(msg) {
    const low = msg.toLowerCase();
    setSugs([]);
    const T = getTaux(data.tauxChange || {});

    // ── Définitions pédagogiques (KNOWLEDGE) ──────────────
    if (low.includes('vitrine') || (low.includes('site') && !low.includes('e-commerce') && !low.includes('boutique') && !low.includes('ecommerce'))) {
      const k = KNOWLEDGE['site vitrine']; addBot(`<strong>${k.title}</strong><br>${k.html}`); setSugs(k.sugs); return;
    }
    if (low.includes('e-commerce') || low.includes('ecommerce') || low.includes('vente en ligne')) {
      const k = KNOWLEDGE['site e-commerce']; addBot(`<strong>${k.title}</strong><br>${k.html}`); setSugs(k.sugs); return;
    }
    if (low.includes('application web') || low.includes('appli web') || low.includes('flask') || low.includes('react')) {
      const k = KNOWLEDGE['application web']; addBot(`<strong>${k.title}</strong><br>${k.html}`); setSugs(k.sugs); return;
    }
    if (low.includes('système') || low.includes('logiciel') || low.includes('erp')) {
      const k = KNOWLEDGE['système de gestion']; addBot(`<strong>${k.title}</strong><br>${k.html}`); setSugs(k.sugs); return;
    }
    if (low.includes('api') || low.includes('backend') || low.includes('rest') || low.includes('serveur')) {
      const k = KNOWLEDGE['api']; addBot(`<strong>${k.title}</strong><br>${k.html}`); setSugs(k.sugs); return;
    }
    if (low.includes('dashboard') || low.includes('tableau de bord') || low.includes('power bi') || low.includes('visualis')) {
      const k = KNOWLEDGE['dashboard']; addBot(`<strong>${k.title}</strong><br>${k.html}`); setSugs(k.sugs); return;
    }
    if ((low.includes('appli') || low.includes('application')) && (low.includes('mobile') || low.includes('android') || low.includes('ios'))) {
      const k = KNOWLEDGE['application mobile']; addBot(`<strong>${k.title}</strong><br>${k.html}`); setSugs(k.sugs); return;
    }
    if (low.includes('machine learning') || low.includes('deep learning') || low.includes('intelligence artificielle') || (low.includes('ia') && !low.includes('tarif'))) {
      const k = KNOWLEDGE['machine learning']; addBot(`<strong>${k.title}</strong><br>${k.html}`); setSugs(k.sugs); return;
    }
    if (low.includes('data') || low.includes('donnée') || low.includes('statistique')) {
      const k = KNOWLEDGE['data science']; addBot(`<strong>${k.title}</strong><br>${k.html}`); setSugs(k.sugs); return;
    }
    if (low.includes('solaire') || low.includes('panneau') || low.includes('photovolt')) {
      const k = KNOWLEDGE['solaire']; addBot(`<strong>${k.title}</strong><br>${k.html}`); setSugs(k.sugs); return;
    }
    if (low.includes('forage') || low.includes('puits') || (low.includes('eau') && !low.includes('réservoir')) || low.includes('pompe')) {
      const k = KNOWLEDGE['forage']; addBot(`<strong>${k.title}</strong><br>${k.html}`); setSugs(k.sugs); return;
    }
    if (low.includes('graphisme') || low.includes('logo') || low.includes('photocopie') || low.includes('impression') || low.includes('affiche') || low.includes('bannière')) {
      const k = KNOWLEDGE['graphisme']; addBot(`<strong>${k.title}</strong><br>${k.html}`); setSugs(k.sugs); return;
    }

    // ── Mobile Money spécifique ────────────────────────────
    if (low.includes('mtn') || (low.includes('momo') && !low.includes('moov'))) { addUser_and_showOp('MTN Mobile Money'); return; }
    if (low.includes('moov')) { addUser_and_showOp('Moov Money'); return; }
    if (low.includes('celtis') || low.includes('celtiis')) { addUser_and_showOp('Celtis Cash'); return; }

    if (low.includes('paie') || low.includes('payer') || low.includes('comment payer') || low.includes('virement') || low.includes('money') || low.includes('banque') || low.includes('transfert')) {
      showAllPayment(); return;
    }

    // ── Boutique KotosShop ("Nos Applications, Prêtes à l'Emploi") ──
    if (low.includes('boutique') || low.includes('kotosshop') || low.includes('kotos shop') || low.includes('catalogue') || low.includes('prête à l\'emploi') || low.includes('prêtes à l\'emploi')) {
      addBot(
        `🛍️ <strong>KotosShop — Nos applications prêtes à l'emploi :</strong><br><br>` +
        (data.produits || []).filter(p => p.active).map(p =>
          `<strong>${p.icon} ${p.name}</strong><br>&nbsp;<span style="color:#8AAAC8">${p.desc}</span><br>` +
          `&nbsp;💰 ${p.onDevis ? 'Sur devis' : `<strong style="color:#F5C842">${p.priceFcfa.toLocaleString('fr-FR')} FCFA/${p.unit}</strong>`}`
        ).join('<br><br>') +
        `<br><br>🛒 Achat en un clic, essai gratuit sur la plupart, paiement Mobile Money ou carte via FedaPay.<br>` +
        `👉 Dites-moi le nom d'une application pour plus de détails !`
      );
      setSugs(['💰 Tous les tarifs','📞 Demander un devis','🚀 Digitalisation']);
      return;
    }

    // ── Digitalisation d'entreprises ──────────────────────
    if (low.includes('digitalisation') || low.includes('digitaliser') || low.includes('transformation numérique')) {
      addBot(
        `🚀 <strong>Digitalisation d'entreprises — nos secteurs :</strong><br><br>` +
        (data.digitalisation?.secteurs || []).map(s =>
          `<strong>${s.icon} ${s.name}</strong><br>&nbsp;<span style="color:#8AAAC8">${s.desc}</span><br>` +
          s.packs.map(pk => `&nbsp;• Pack ${pk.name} : <strong style="color:#F5C842">${pk.prixFcfa.toLocaleString('fr-FR')} FCFA</strong>`).join('<br>')
        ).join('<br><br>') +
        `<br><br>👉 Dites-moi votre secteur (commerce, santé, éducation, église...) pour plus de détails !`
      );
      setSugs(['💰 Tous les tarifs','📞 Demander un devis']);
      return;
    }

    // ── Prochaines applications (pipeline) ────────────────
    if (low.includes('bientôt') || low.includes('prochain') || low.includes('pipeline') || low.includes('à venir')) {
      addBot(
        `🚧 <strong>Nos prochaines applications :</strong><br><br>` +
        (data.pipeline || []).map(p => `<strong>${p.icon} ${p.name}</strong><br>&nbsp;<span style="color:#8AAAC8">${p.desc}</span>`).join('<br><br>')
      );
      setSugs(['🛍️ Boutique KotosShop','📞 Contact']);
      return;
    }

    // ── Tarifs (packs SaaS/Data/Support/Formation/Mémoires) ──
    if (low.includes('tarif') || low.includes('prix') || low.includes('combien') || low.includes('coût') || low.includes('dollar') || low.includes('euro') || low.includes('usd')) {
      let t = '💰 <strong>Aperçu de nos tarifs :</strong><br><br>';
      allTarifs.forEach(sec => {
        const lignes = sec.plans || sec.modules || sec.forfaits || [];
        if (lignes.length === 0) return;
        t += `<strong>${sec.icon} ${sec.title}</strong><br>`;
        lignes.slice(0, 3).forEach(p => {
          const prixStr = p.fcfa != null
            ? `${p.fcfa.toLocaleString('fr-FR')} FCFA`
            : 'Sur devis';
          t += `&nbsp;• ${p.name} : <strong style="color:#F5C842">${prixStr}</strong>${p.unit ? '/' + p.unit : ''}<br>`;
        });
        t += '<br>';
      });
      t += `💱 1 USD = ${T.USD} FCFA | 1 EUR = ${T.EUR} FCFA<br><br>`;
      t += '💡 <strong>Acompte 30% obligatoire</strong> avant démarrage. Dites-moi quel service vous intéresse pour un tarif précis !';
      addBot(t);
      setSugs(['🛍️ Boutique KotosShop','🚀 Digitalisation','🎓 Formations','📞 Demander un devis']);
      return;
    }

    // ── Services généraux (liste des 6 domaines) ──────────
    if (low.includes('service') || low.includes('prestation') || low.includes('domaine') || low.includes('que faites') || low.includes('que proposez')) {
      addBot(
        `🛠 <strong>Nos domaines d'expertise :</strong><br><br>` +
        (data.domaines || []).map(d =>
          `<strong>${d.icon} ${d.name}</strong><br>&nbsp;<span style="color:#8AAAC8">${d.desc}</span>` +
          (d.priceFcfa != null
            ? `<br>&nbsp;💰 ${d.priceLabel} <strong style="color:#F5C842">${d.priceFcfa.toLocaleString('fr-FR')} FCFA</strong>`
            : d.price ? `<br>&nbsp;💰 ${d.priceLabel || ''} <strong style="color:#F5C842">${d.price}</strong>` : ''
          )
        ).join('<br><br>') +
        `<br><br>👉 Cliquez sur un service ci-dessous pour une explication détaillée.`
      );
      setSugs(['🌐 Site vitrine','📊 Data Science','☀️ Solaire','🔩 Forage','🏡 Immobilier','🖨️ Graphisme']);
      return;
    }

    // ── Formations ──────────────────────────────────────
    if (low.includes('formation') || low.includes('certif') || low.includes('cours') || low.includes('apprendre')) {
      addBot(
        `🎓 <strong>Nos formations certifiantes :</strong><br><br>` +
        (data.formations || []).map(f =>
          `<strong>${f.icon} ${f.title}</strong><br>` +
          `&nbsp;⏱ ${f.duree} · 👥 ${f.places} · 📍 ${f.mode}<br>` +
          `&nbsp;💰 <strong style="color:#F5C842">${(f.fcfa ?? f.price)?.toLocaleString?.('fr-FR') ?? f.price} FCFA</strong>`
        ).join('<br><br>') +
        `<br><br>✅ Certificat KOTOSTECHNOLOGY délivré à la fin.`
      );
      setSugs(['💰 Tous les tarifs','📞 S\'inscrire','🛠 Nos services']);
      return;
    }

    // ── Immobilier ──────────────────────────────────────
    if (low.includes('immob') || low.includes('terrain') || low.includes('parcelle') || low.includes('loyer') || low.includes('location')) {
      addBot(
        `🏡 <strong>Services immobiliers :</strong><br><br>` +
        (data.immo || []).map(im =>
          `<strong>${im.icon} ${im.title}</strong><br>&nbsp;<em>${im.sub}</em><br>` +
          im.items.filter(i => i.price).map(i =>
            `&nbsp;• ${i.title} : <strong style="color:#00FF88">${i.price}</strong>`
          ).join('<br>')
        ).join('<br><br>')
      );
      setSugs(['📞 Contact','💰 Tarifs']);
      return;
    }

    // ── Contact / adresse ─────────────────────────────────
    if (low.includes('contact') || low.includes('téléphone') || low.includes('telephone') || low.includes('appel') || low.includes('whatsapp') || low.includes('numéro')) {
      addBot(
        `📞 <strong>Nos coordonnées :</strong><br><br>` +
        `📱 <strong>Tél / WhatsApp :</strong> ${data.contact.tel}<br>` +
        `📧 <strong>Email :</strong> ${data.contact.email}<br>` +
        `🌐 <strong>Web :</strong> www.kotostechnology.com<br>` +
        `📍 <strong>Adresse :</strong> ${data.contact.address}<br>` +
        `🕒 <strong>Horaires :</strong> ${data.contact.hours}`
      );
      setSugs(['💳 Comment payer ?','📍 Adresse','🛠 Nos services']);
      return;
    }
    if (low.includes('adresse') || low.includes('où') || low.includes('situé') || low.includes('localisa') || low.includes('godomey')) {
      addBot(`📍 <strong>Notre adresse :</strong><br><br>${data.contact.address}<br><br>🕒 ${data.contact.hours}<br>📞 ${data.contact.tel}`);
      setSugs(['📞 Contact','🛠 Nos services']);
      return;
    }

    // ── Salutations ────────────────────────────────────
    if (low.includes('bonjour') || low.includes('bonsoir') || low.includes('salut') || low.includes('hello') || low === 'hi') {
      addBot(`👋 Bonjour ! Je suis <strong>KotoBot</strong>.<br>Comment puis-je vous aider aujourd'hui ?`);
      setSugs(['🌐 Site vitrine','🛍️ Boutique KotosShop','☀️ Solaire','💳 Comment payer ?','📞 Contact']);
      return;
    }
    if (low.includes('merci') || low.includes('thank') || low.includes('parfait') || low.includes('super') || low.includes('ok')) {
      addBot(`🙏 Avec plaisir ! N'hésitez pas si vous avez d'autres questions.<br>📞 ${data.contact.tel}`);
      setSugs(['🛠 Nos services','📞 Contact']);
      return;
    }

    // ── Recherche dynamique dans TOUT le catalogue ────────
    // Avant le fallback générique : on cherche si le message
    // correspond à un produit/pack/formation/domaine précis,
    // même sans mot-clé codé en dur ci-dessus. C'est CE bloc
    // qui rend le bot "dynamique" — toute donnée ajoutée dans
    // Admin devient automatiquement reconnaissable ici.
    const idx = buildCatalogIndex(data);
    const hit = searchCatalog(idx, msg);
    if (hit) {
      addBot(formatCatalogAnswer(hit, T));
      setSugs(['💰 Tous les tarifs', '📞 Demander un devis', '🛠 Nos services']);
      return;
    }

    // ── Fallback final ─────────────────────────────────
    addBot(
      `Je n'ai pas trouvé de correspondance exacte. Voici comment je peux vous aider :<br><br>` +
      `<strong>💻 Web :</strong> Site vitrine, e-commerce, application, système<br>` +
      `<strong>🛍️ Boutique :</strong> KotosShop — applications prêtes à l'emploi<br>` +
      `<strong>🚀 Digitalisation :</strong> commerce, santé, éducation, église<br>` +
      `<strong>📊 Data :</strong> Analyse, Machine Learning, tableau de bord<br>` +
      `<strong>☀️ Énergie :</strong> Panneaux solaires, forage, eau<br>` +
      `<strong>💳 Paiement :</strong> MTN MoMo, Moov Money, Celtis Cash, banque<br><br>` +
      `📞 Ou appelez-nous directement : <strong>${data.contact.tel}</strong>`
    );
    setSugs(['🌐 Site vitrine','🛍️ Boutique KotosShop','💳 Comment payer ?','📞 Contact']);
  }

  function addUser_and_showOp(name) {
    addUser(name);
    showOperator(name);
  }

  function showOperator(name) {
    const op = OPERATORS.find(o => o.name === name);
    if (!op) return;
    const p = data.paiement;
    const numLine = (p.mobile && p.mobile !== 'Non renseigné')
      ? `<br><br>📲 <strong>Numéro ${op.short} de KOTOSTECHNOLOGY :</strong><br><span style="font-size:17px;font-weight:900;color:${op.color};letter-spacing:2px">${p.mobile}</span>`
      : `<br><br><em style="color:#8AAAC8">→ Numéro communiqué à la confirmation de commande.</em>`;

    addBot(
      `${op.emoji} <strong>${op.name}</strong><br>` +
      `<span style="color:#8AAAC8">${op.comment}</span><br>` +
      `Préfixes : ${op.prefixes.map(p => `<strong>${p}xx</strong>`).join(', ')} · USSD : <strong style="color:${op.color}">${op.ussd}</strong>` +
      numLine +
      `<br><br><strong>🪜 Étapes pour payer :</strong><br>` +
      op.steps.map((s, i) => `&nbsp;<strong style="color:${op.color}">${i+1}.</strong> ${s}`).join('<br>') +
      `<br><br>💡 <em>Conservez votre SMS de confirmation et communiquez-le à votre chargé de compte.</em>`
    );
    const others = OPERATORS.filter(o => o.name !== name);
    setSugs([`${others[0].emoji} ${others[0].short}`, `${others[1].emoji} ${others[1].short}`, '🏦 Virement bancaire', '📞 Contact']);
  }

  function showAllPayment() {
    const p = data.paiement;
    const hasBank = p.bank && p.bank !== 'Non renseigné';
    const numMap2 = { 'MTN Mobile Money': p.mtn, 'Moov Money': p.moov, 'Celtis Cash': p.celtis };
    addBot(
      `💳 <strong>Nos moyens de paiement :</strong><br><br>` +
      `<strong>📱 MOBILE MONEY</strong><br>` +
      OPERATORS.map(op => {
        const n = numMap2[op.name];
        const numStr = (n && n.trim()) ? ` · <strong style="color:${op.color};font-family:monospace">${n}</strong>` : ' · <em style="color:#8AAAC8">num. sur demande</em>';
        return `&nbsp;${op.emoji} <strong>${op.name}</strong>${numStr}<br>&nbsp;&nbsp;<span style="color:#8AAAC8">${op.ussd} · ${op.comment}</span>`;
      }).join('<br>') +
      `<br><br>` +
      `<strong>🏦 VIREMENT BANCAIRE</strong><br>` +
      (hasBank ? `&nbsp;${p.bank.replace(/\n/g,'<br>&nbsp;')}` : `&nbsp;<em style="color:#8AAAC8">Coordonnées communiquées après établissement du devis.</em>`) +
      (p.other ? `<br><br><strong>💵 AUTRES</strong><br>&nbsp;${p.other}` : '') +
      `<br><br><strong>📋 Règles importantes :</strong><br>` +
      `&nbsp;• Acompte <strong>30%</strong> requis avant tout démarrage<br>` +
      `&nbsp;• Conservez toujours votre reçu / SMS de confirmation<br>` +
      `&nbsp;• Précisez votre nom et numéro de devis lors du paiement`
    );
    setSugs(['🟡 MTN MoMo','🔵 Moov Money','🟢 Celtis Cash','🏦 Virement bancaire','📞 Contact']);
  }

  function handleSug(s) {
    const low = s.toLowerCase();
    addUser(s);
    if (low.includes('mtn') || low.includes('momo')) { showOperator('MTN Mobile Money'); return; }
    if (low.includes('moov'))   { showOperator('Moov Money');   return; }
    if (low.includes('celtis')) { showOperator('Celtis Cash');  return; }
    if (low.includes('virement') || low.includes('bancaire')) {
      const p = data.paiement;
      const hasBank = p.bank && p.bank !== 'Non renseigné';
      addBot(
        `🏦 <strong>Virement Bancaire</strong><br><br>` +
        (hasBank ? p.bank.replace(/\n/g,'<br>') : `Les coordonnées bancaires complètes vous seront communiquées par email ou WhatsApp après établissement du devis.<br><br>📧 ${data.contact.email}<br>📞 ${data.contact.tel}`) +
        `<br><br>💡 Indiquez le numéro de votre facture dans l'intitulé du virement.`
      );
      setSugs(['🟡 MTN MoMo','🔵 Moov Money','🟢 Celtis Cash','📞 Contact']);
      return;
    }
    respond(s);
  }

  function handleSend() {
    if (!input.trim()) return;
    const msg = input.trim();
    addUser(msg);
    setInput('');
    respond(msg);
  }

  return (
    <>
      <button className="chat-btn" onClick={() => { setOpen(o => !o); setBadge(false); }}>
        💬{badge && <span className="chat-badge">!</span>}
      </button>

      {open && (
        <div className="chat-box">
          <div className="cb-head">
            <div className="cb-info">
              <img src={logo} alt="" />
              <div>
                <div className="cb-name">KotoBot — Assistant KOTOSTECHNOLOGY</div>
                <div className="cb-status">En ligne &amp; disponible</div>
              </div>
            </div>
            <button className="cb-close-btn" onClick={() => setOpen(false)}>✕</button>
          </div>

          <div className="cb-msgs" ref={msgsRef}>
            {msgs.map((m, i) => (
              <div key={i} className={`cb-msg ${m.type}`} dangerouslySetInnerHTML={{ __html: m.html }} />
            ))}
          </div>

          {sugs.length > 0 && (
            <div className="cb-sugs">
              {sugs.map((s, i) => (
                <button key={i} className="cb-sug" onClick={() => handleSug(s)}>{s}</button>
              ))}
            </div>
          )}

          <div className="cb-inp-area">
            <input
              className="cb-inp"
              placeholder="Ex : c'est quoi KotosCloud ?"
              value={input}
              onChange={e => setInput(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && handleSend()}
            />
            <button className="cb-send" onClick={handleSend}>➤</button>
          </div>
        </div>
      )}
    </>
  );
}